<template>
    <v-card class="mt-2 ml-2 mr-2" elevation="0">
      <AdminInsentif></AdminInsentif>
    </v-card>
  </template>
  
  <script>

  

  import AdminInsentif from "@/components/admin-insentif/AdminInsentif.vue";

  export default {
    name: "AdminInsentifView",
    components: {
      AdminInsentif
    },
    data() {
      return {
      }
    },
    computed: {
    },
    methods: {
    },
  
  
  }
  </script>
  
  <style scoped>
  </style>